import React, { useState, useEffect } from "react";
import qs from "qs";
import axios from "axios";
import * as constants from "../constants/domains";
import { toast } from "react-toastify";
import * as helpers from "../helpers/helpers";
import VerificationInput from "react-verification-input";
import CountdownTimer from "../components/Counter"; 

function CheckPhoneNumber(props) {
  const [inputPhoneNumber, setInputPhoneNumber] = useState("09");
  // const [clientIp, setClientIp] = useState("");
  const [inputRegEx] = useState(
    /^9\d{0,9}$|^0\d{0,10}$|^(۹)[۰۱۲۳۴۵۶۷۸۹]{0,9}$|^۰[۰۱۲۳۴۵۶۷۸۹]{0,10}$/
  );
  const [inputValidationRegEx] = useState(
    /^(09|9)\d{9}|(۰۹|۹)[۰۱۲۳۴۵۶۷۸۹]{9}$/
  );
  const [validationError, setValidationError] = useState({});
  const [loading, setLoading] = useState(false);
  // const [pageLoading, setPageLoading] = useState(true);
  const [callBack, setCallBack] = useState("");
  const [site, setSite] = useState("");
  const [timer, setTimer] = useState("");
  const [block, setBlock] = useState(false);
  const [addToSegment, setAddToSegment] = useState(false);
  const [ip, setIp] = useState(false);
  // const { executeRecaptcha } = useGoogleReCaptcha();

  // useEffect(() => {
  //     setPageLoading(true);
  //     axios
  //         .get("https://api.ipify.org/?format=json")
  //         .then(({ data }) => {
  //             setPageLoading(false);
  //             setClientIp(data.ip);
  //             console.log(data.ip);
  //         })
  //         .catch((err) => {
  //             setPageLoading(false);
  //             console.log(err);
  //         });
  // }, []);

  const { history } = props;
  const { location } = props;
  useEffect(() => {
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    console.log(queryParams);
    if (!queryParams) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
      setSite("shop");
    } else if (
      queryParams["site"] !== "class" &&
      queryParams["site"] !== "shop"
    ) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
      setSite("shop");
    } else {
      setSite(queryParams["site"]);
      setCallBack(queryParams["callBack"] ? queryParams["callBack"] : "");
    }

    if (queryParams && queryParams["addToSegment"] == "true") {
      setAddToSegment(true);
    } else {
      setAddToSegment(false);
    }
  }, [history, location]);

  const formSubmit = async (event) => {
    event.preventDefault();
    // if (!executeRecaptcha) {
    //   alert("کپچا آماده نشده است !");
    //   event.stopPropagation();
    //   return;
    // }
    // const tokenRecaptcha = await executeRecaptcha("submit");

    event.preventDefault();
    if (
      inputPhoneNumber !== "" &&
      inputValidationRegEx.test(inputPhoneNumber)
    ) {
      console.log("username",inputPhoneNumber);
      
      setLoading(true);
      axios
        .post(constants.$apiUrl + "/api/check-phone-number", {
          username: inputPhoneNumber,
          // captcha: tokenRecaptcha,

          // ip: clientIp,
        })
        .then((response) => {
          setLoading(false);
          setValidationError({});

          if (response.data.data.action === "confirmMobile") {
            const search = qs.stringify({
              site: site,
              callBack: callBack,
              token: window.btoa(helpers.fa_to_eng_number(inputPhoneNumber)),
              addToSegment: addToSegment,
            });
            props.history.push({
              pathname: "/user/confirm-mobile",
              search: "?" + search,
            });
          } else if (response.data.data.action === "login") {
            const search = qs.stringify({
              site: site,
              callBack: callBack,
              token: window.btoa(helpers.fa_to_eng_number(inputPhoneNumber)),
              addToSegment: addToSegment,
            });
            props.history.push({
              pathname: "/user/login",
              search: "?" + search,
            });
          } else if (response.data.data.action === "block") {
            toast.error(
              " به دلیل " +
                " " +
                response.data.data.response.display_description +
                " " +
                "شما بلاک هستید و امکان خرید و استفاده از سایت رو ندارید",
              {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          } else {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.response && error.response.status === 400) {
            setValidationError({ ...error.response.data.data });
            if (error.response && error.response.data.data == "Limited") {
              if (error.response && error.response.data.limitTime > 0) {
                setTimer(error.response.data.limitTime);
              }
              if (error.response && error.response.data.limitTime == -1) {
                setBlock(true);
                setIp(error.response.data.ip);
              } else {
                setBlock(false);
                setIp(error.response.data.ip);
              }
            }
            toast.error(
              "تعداد درخواست های شما به سرور زیاد شده است . لطفا دقایقی دیگر مجددا امتحان کنید ",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          } else if (error.response && error.response.status === 409) {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          } else if (error.response && error.response.status === 429) {
            toast.error(
              "تعداد درخواست های شما به سرور زیاد شده است . لطفا دقایقی دیگر مجددا امتحان کنید ",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          } else {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        });
    } else {
      setValidationError({ username: ["فرمت تلفن همراه معتبر نیست."] });
    }
  };

  const onlyNumeric = (event) => {
    if (event === "" || inputRegEx.test(event)) {
      setInputPhoneNumber(event);
    }
  };

  return (
    <React.Fragment>
      <div className="container">
        <div className="card-group card-authentication mx-auto mb-5">
          <div className="login-card">
            <div className="card-content direction-rtl">
              <div className="form-header-logo">
                <img
                  src={constants.$authUrl + "/images/honari_logo.png"}
                  alt="هنری دات کام"
                />
                <div className="logo-text">
                  <p className="logo-honari-text">هـنـری</p>
                  <p className="logo-desc-text">تحقق رویای هنرمندانه‌ تو</p>
                </div>
              </div>
              <div className={"form-header"}>ورود / ثبت‌نام</div>
              <form onSubmit={(event) => formSubmit(event)}>
                <div className="mb-4 row">
                  <label htmlFor="username" className={"login-mobile-message"}>
                    لطفا شماره موبایل خود را وارد کنید
                  </label>
                  <div
                    className={"login-form-row"}
                    style={{ fontSize: "16px!important" }}
                  >
                    <VerificationInput
                      id="username"
                      className={
                        "form-field IRANSans " +
                        (validationError["username"] &&
                        Array.isArray(validationError["username"])
                          ? "not-valid "
                          : "")
                      }
                      onChange={(event) => onlyNumeric(event)}
                      autoComplete="username"
                      autoFocus={"auto"}
                      value={inputPhoneNumber}
                      length={11}
                      placeholder=""
                    />

                    {validationError["username"] &&
                    Array.isArray(validationError["username"])
                      ? validationError["username"].map((item, index) => {
                          return (
                            <div key={index} className={"validation-error"}>
                              {item}
                            </div>
                          );
                        })
                      : null}
                  </div>

                  {/* <ReCAPTCHA sitekey="6Le05tsqAAAAAPDwhxolFahvIisrci5_75QTq4pk" type="image"  onChange={setCaptcha} /> */}

                  {timer > 0 && (
                    <div className="mt-3">
                      <span className="pb-4 text-danger">
                        بدلیل درخواست زیاد شماره شما محدود شده است
                      </span>
                      <div className="mt-2">
                        {" "}
                        <CountdownTimer minutes={timer} />
                      </div>
                    </div>
                  )}
                  {block && (
                    <span className="pb-4  text-danger">
                      بدلیل درخواست زیاد شماره شما محدود شده است لطفا با
                      پشتیبانی تماس بگیرید
                      <br />
                      <span>ip : {ip}</span>
                      <br />
                    </span>
                  )}
                </div>
                <div className="row">
                  <div className={"my-3"}>
                    {loading ? (
                      <button
                        disabled={true}
                        className="btn btn-honari w-100 py-2"
                      >
                        در حال ارسال اطلاعات...
                      </button>
                    ) : (
                      <button className="btn btn-honari w-100 py-2">
                        ورود به هنری
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CheckPhoneNumber;
